import getStore from '../store/store';
import getRowDataForSpotlightItem from '../utils/getRowDataForSpotlightItem';
import { MailListRowDataType, TableView } from 'owa-mail-list-store';

export default async function getSpotlightRows(
    tableView: TableView,
    isConversationView: boolean
): Promise<MailListRowDataType[]> {
    const spotlightItems = getStore().spotlightItems;
    const spotlightRows: MailListRowDataType[] = [];

    for (const spotlightItem of spotlightItems) {
        const spotlightRow = await getRowDataForSpotlightItem(
            isConversationView ? spotlightItem.conversationId : spotlightItem.itemId,
            tableView
        );
        spotlightRows.push(spotlightRow);
    }

    return spotlightRows;
}
